module.exports = __webpack_public_path__ + "img/quest_icon_0036_sword.d53ccf38.png";